import {  createReducer, on } from "@ngrx/store";
import { initialCartState } from "./cart.state";
import * as cartActions from '../cart/cart.actions';






 export const cartReducer = createReducer(
    initialCartState,   
    on(cartActions.loadCart, state => ({
        ...state,
        loading: true,
        })),

    on(cartActions.loadCartSuccess, (state, { cart, numOfCartItems }) => ({
        ...state,
        cart,
        numOfCartItems,
        loading: false,
    })),

    on( cartActions.addToCartSuccess, (state, { cart, numOfCartItems }) => ({
        ...state,
        cart,
        numOfCartItems,
    })),
on(cartActions.removeFromCartSuccess, (state, { cart, numOfCartItems }) => ({
  ...state,
  cart,
  numOfCartItems
})),

  on(cartActions.clearCartSuccess, () => initialCartState),  


  on(cartActions.updateQuantitySuccess, (state, { productId, quantity }) => {
  if (!state.cart) return state;

  const updatedCartItems = state.cart.cartItems.map(item =>
    item.product._id === productId
      ? { ...item, quantity }
      : item
  );

  return {
    ...state,
    cart: {
      ...state.cart,
      cartItems: updatedCartItems
    }
  };
}),


on(cartActions.validateCouponSuccess, (state, { isValid }) => ({
    ...state,
    isValidCoupon: isValid
})),


on(cartActions.applyCouponSuccess, (state, { cart, numOfCartItems}) => ({
  ...state,
  cart,
  numOfCartItems,

})),

 );